import {Injectable, signal, computed, inject, DestroyRef, effect} from '@angular/core';
import {AdsRestService} from "./ads.rest-service";
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {UserService} from "../../../core/user/services/user.service";

@Injectable({
  providedIn: 'root'
})

export class AdsService {
  private readonly destroyRef = inject(DestroyRef);
  private adsRestService: AdsRestService = inject(AdsRestService);
  private userService: UserService = inject(UserService);

  private _currentAds = signal<any[]>([]);
  readonly currentAds = this._currentAds.asReadonly();
  private _currentAdsLoaded = signal(false);
  lastShownStickyId = signal<number | null>(null);


  constructor() {
    effect(() => {
      const idf = this.userService.selectedIdf();
      if (idf) {
        this.loadCurrentAds(idf);
      }
    });
  }

  leftAds = computed(() =>
    this.currentAds()
      .filter(ad => ad.location === 'LEFT')
      .sort((a, b) => {
        if (a.prioritized !== b.prioritized) {
          return a.prioritized ? -1 : 1;
        }
        return a.vendor.sorting - b.vendor.sorting;
      })
  );

  rightAds = computed(() =>
    this.currentAds()
      .filter(ad => ad.location === 'RIGHT')
      .sort((a, b) => {
        if (a.prioritized !== b.prioritized) {
          return a.prioritized ? -1 : 1;
        }
        return a.vendor.sorting - b.vendor.sorting;
      })
  );

  dashboardAds = computed(() =>
    this.currentAds().filter(ad => ad.location === 'STICKY_BANNER')
      .sort((a, b) => {
        if (a.prioritized !== b.prioritized) {
          return a.prioritized ? -1 : 1;
        }
        return a.vendor.sorting - b.vendor.sorting;
      })
  );

  loadCurrentAds(selectedIdf: string) {
    if (!selectedIdf) return;
    this.adsRestService.getCurrentAds(selectedIdf)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response: any) => {
          const ads = response.return_object || [];
          this._currentAds.set(ads);
          this._currentAdsLoaded.set(true);
        },
        error: (error: any) => {
          console.error('Error loading all ads:', error);
        }
      });
  }
}
